import { Locale } from "../../../../modules/locale";

// Shared Keys
Locale.getInstance().registerKeySet("fr", "workshopForm", {
  openFormButton: "Remplir le formulaire d'inscription",
  submitButton: "Envoyer",
  submittedMessage: "Votre demande a été envoyée.",
  fieldLabels: {
    name: "Nom",
    email: "Adresse courriel",
    phone: "Numéro de téléphone",
    phoneExtension: "Poste (optionnel)",
    school: "Nom de l'école",
    academicCenter: "Nom du centre de services scolaires",
    region: "Région",
    educationLevel: "Niveau scolaire de votre classe",
    participants: "Nombre de jeunes dans votre classe",
    regionsOption:
      "Abitibi-Témiscamingue,Bas-Saint-Laurent,Capitale-Nationale,Centre-du-Québec,Chaudière-Appalaches,Côte-Nord,Estrie,Gaspésie–Îles-de-la-Madeleine,Lanaudière,Laurentides,Laval,Mauricie,Montérégie,Montréal,Nord-du-Québec,Outaouais,Saguenay–Lac-Saint-Jean",
    datesRequested: "Dates souhaitées pour les ateliers",
  },
  errorMessages: {
    required: "Requis",
    invalidEmail: "Le courriel est invalide",
    invalidPhone: "Le numéro de téléphone est invalide",
  },
  contactInfoHeading: "Informations du contact principal",
  educationGroupsHeading: "Nombre de groupes à rencontrer",
  educationGroups: {
    "6e année": "6e année",
    "Secondaire 1": "Secondaire 1",
    "Secondaire 2": "Secondaire 2",
    "Secondaire 3": "Secondaire 3",
    "Secondaire 4": "Secondaire 4",
    "Secondaire 5": "Secondaire 5",
    "Adaptation scolaire": "Adaptation scolaire",
  },
});
Locale.getInstance().registerKeySet("en", "workshopForm", {
  openFormButton: "Complete the registration form",
  submitButton: "Submit",
  submittedMessage: "Your request has been sent.",
  fieldLabels: {
    name: "Full Name",
    email: "Email",
    phone: "Phone Number",
    phoneExtension: "Extension (optional)",
    school: "Name of School",
    academicCenter: "Name of Academic Services Center",
    region: "Region",
    educationLevel: "Class Education Level",
    participants: "Number of students in the class",
    regionsOption:
      "Abitibi-Témiscamingue,Bas-Saint-Laurent,Capitale-Nationale,Centre-du-Québec,Chaudière-Appalaches,Côte-Nord,Estrie,Gaspésie–Îles-de-la-Madeleine,Lanaudière,Laurentides,Laval,Mauricie,Montérégie,Montréal,Nord-du-Québec,Outaouais,Saguenay–Lac-Saint-Jean",
    datesRequested: "Requested Dates for Workshops",
  },
  errorMessages: {
    required: "Required",
    invalidEmail: "Email is invalid",
    invalidPhone: "Phone number is invalid",
  },
  contactInfoHeading: "Contact Information",
  educationGroupsHeading: "Number of groups to meet",
  educationGroups: {
    "6e année": "Grade 6",
    "Secondaire 1": "Secondary 1",
    "Secondaire 2": "Secondary 2",
    "Secondaire 3": "Secondary 3",
    "Secondaire 4": "Secondary 4",
    "Secondaire 5": "Secondary 5",
    "Adaptation scolaire": "Special Education",
  },
});
